// Copyright 2021 Sorama B.V.

import { Grid } from "controls/plot/grid-plot/GridData";
import { Point3D, Region } from "datatypes/SoramaLocalApi";
import { Length } from "units/Length";
import { IVideoCalibration } from "./IVideoCalibration";

export class RegionBasedVideoCalibration implements IVideoCalibration {
    public readonly grid: Grid;
    public readonly targetPoints: Point3D[];

    constructor(
        private readonly resolution: { width: number; height: number },
        private readonly distance: number,
        public readonly visibleRegion: Region
    ) {
        this.targetPoints = this.computeTargetPoints();
        this.grid = this.computeGrid();
    }

    private computeTargetPoints(): Point3D[] {
        const targetPoints = <Point3D[]>[];
        const width = this.visibleRegion.width;
        const height = this.visibleRegion.height;

        const resX = this.resolution.width;
        const resY = this.resolution.height;

        for (let y = 0; y < resY; y++) {
            for (let x = 0; x < resX; x++) {
                targetPoints.push({
                    x: ((x + 0.5) / resX) * width - width * 0.5 + this.visibleRegion.centerX,
                    y: ((y + 0.5) / resY) * height - height * 0.5 + this.visibleRegion.centerY,
                    z: this.distance,
                });
            }
        }

        return targetPoints;
    }

    private computeGrid(): Grid {
        const resX = this.resolution.width;
        const resY = this.resolution.height;
        const width = this.visibleRegion.width;
        const height = this.visibleRegion.height;

        return new Grid(
            { x: resX, y: resY },
            { x: width / resX, y: height / resY },
            { x: this.visibleRegion.centerX, y: this.visibleRegion.centerY },
            Length.meter
        );
    }
}
